import React from 'react'
import DownLoadBG01 from '../../../../assets/bg/mobile/bg_download_01.png'
import DownLoadBG02 from '../../../../assets/bg/mobile/bg_download_02.png'
import DownLoadBG03 from '../../../../assets/bg/mobile/bg_download_03.png'
import DownLoadBG04 from '../../../../assets/bg/mobile/bg_download_04.png'
import Float from '../../../../styles/float/Float'
import Outer from '../../../../styles/outer/Outer'
import WhitePaperEng from '../../../../assets/pdf/MCN_Mainnet_Whitepaper_ENG.pdf'
import WhitePaperKor from '../../../../assets/pdf/MCN_Mainnet_Whitepaper_KOR.pdf'
import PlanningKor from '../../../../assets/pdf/planning_kor.pdf'
import PlanningEng from '../../../../assets/pdf/planning_eng.pdf'
import LightPaperKor from '../../../../assets/pdf/NFTMOA_Light Paper_KOR.pdf'
import LightPaperEng from '../../../../assets/pdf/NFTMOA_Light Paper_ENG.pdf'
import IrBookEng from '../../../../assets/pdf/LABSHIGH_IR BOOK_ENG.pdf'
import IrBookKor from '../../../../assets/pdf/LABSHIGH_IR BOOK_KOR.pdf'
import styled from 'styled-components'

import volume01Kor from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume1_KOR.pdf'
import volume01Eng from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume1_ENG.pdf'

// import volume02KorOld from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume2_KOR.pdf'
// import volume02Kor from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume2_KOR_1.0.pdf'
import volume02Kor from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume2_KOR.pdf'
import volume02Eng from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume2_ENG.pdf'

import whitepaperKor from '../../../../assets/pdf/mverse/MCN_Mainnet_Whitepaper_KOR.pdf'
import whitepaperEng from '../../../../assets/pdf/mverse/MCN_Mainnet_Whitepaper_ENG.pdf'

import projectKor from '../../../../assets/pdf/mverse/(Official) M_Verse PROJECT PLANNING_KOR.pdf'
import projectEng from '../../../../assets/pdf/mverse/(Official) M_Verse PROJECT PLANNING_ENG.pdf'

const MainnetMobileComponent: React.FC = () => {
  return (
    <Wrap>
      <Outer>
        <img src={DownLoadBG01} />
        <ServiceList>
          <a className={'item-eng'} download={'LABSHIGH_IR M_Verse_IR_BOOK_Volume1_ENG.pdf'} href={volume01Eng} />
          <a className={'item-kor'} download={'LABSHIGH_IR M_Verse_IR_BOOK_Volume1_KOR.pdf'} href={volume01Kor} />
        </ServiceList>
      </Outer>

      <Outer>
        <img src={DownLoadBG02} />
        <WhitepaperList>
          <a className='item-eng' download={'M_Verse_IR_BOOK_Volume2_ENG.pdf'} href={volume02Eng} />
          <a className='item-kor' download={'M_Verse_IR_BOOK_Volume2_KOR.pdf'} href={volume02Kor} />
        </WhitepaperList>
      </Outer>

      <Outer>
        <img src={DownLoadBG03} />
        <LightpaperList>
          <a className='item-eng' download={'MCN_Mainnet_Whitepaper_ENG'} href={whitepaperEng} />
          <a className='item-kor' download={'MCN_Mainnet_Whitepaper_KOR'} href={whitepaperKor} />
        </LightpaperList>
      </Outer>

      <Outer>
        <img src={DownLoadBG04} />
        <PlanningList>
          <a className='item-eng' download={'(Official) M_Verse PROJECT PLANNING_ENG.pdf'} href={projectEng} />
          <a className='item-kor' download={'(Official) M_Verse PROJECT PLANNING_KOR.pdf'} href={projectKor} />
        </PlanningList>
      </Outer>
    </Wrap>
  )
}

export default MainnetMobileComponent

const Wrap = styled.div`
  background-color: #f5f5f5;
  margin-bottom: -130px;
`

const ServiceList = styled.div`
  position: absolute;
  width: 85%;
  height: 39.5%;
  top: 50.6%;
  bottom: auto;
  right: 8%;

  & > a {
    position: absolute;
    width: 100%;
    height: 44%;
  }

  .item-eng {
    top: 0;
  }

  .item-kor {
    top: 55%;
  }
`

const WhitepaperList = styled.div`
  position: absolute;
  width: 85%;
  height: 48.5%;
  top: 40.6%;
  bottom: auto;
  right: 8%;

  & > a {
    position: absolute;
    width: 100%;
    height: 44%;
  }

  .item-eng {
    top: 0;
  }

  .item-kor {
    top: 55%;
  }
`

const LightpaperList = styled.div`
  position: absolute;
  width: 85%;
  height: 48.5%;
  top: 40.6%;
  bottom: auto;
  right: 8%;

  & > a {
    position: absolute;
    width: 100%;
    height: 44%;
  }

  .item-eng {
    top: 0;
  }

  .item-kor {
    top: 55%;
  }
`

const PlanningList = styled.div`
  position: absolute;
  width: 85%;
  height: 42.5%;
  top: 32.6%;
  bottom: auto;
  right: 8%;

  & > a {
    position: absolute;
    width: 100%;
    height: 44%;
  }

  .item-eng {
    top: 0;
  }

  .item-kor {
    top: 55%;
  }
`
